import { render, staticRenderFns } from "./BrokerAmendmentEntry.vue?vue&type=template&id=7b1b1ad2&scoped=true"
import script from "./BrokerAmendmentEntry.vue?vue&type=script&lang=js"
export * from "./BrokerAmendmentEntry.vue?vue&type=script&lang=js"
import style0 from "./BrokerAmendmentEntry.vue?vue&type=style&index=0&id=7b1b1ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b1ad2",
  null
  
)

export default component.exports